module.exports = __webpack_public_path__ + "img/volume_up-24px.e69951cf.svg";